import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), n = /* @__PURE__ */ l("path", {
  fill: "#D80027",
  d: "M19.13 20H40c0-1.805-.24-3.554-.689-5.217h-20.18V20Zm0-10.435h17.935a20.105 20.105 0 0 0-4.615-5.217H19.13v5.217ZM20 40c4.707 0 9.033-1.627 12.45-4.348H7.55A19.913 19.913 0 0 0 20 40ZM2.936 30.435h34.129a19.88 19.88 0 0 0 2.246-5.218H.69a19.881 19.881 0 0 0 2.247 5.218Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#0052B4",
  d: "M9.264 3.123h1.823L9.392 4.355l.647 1.993-1.695-1.232-1.695 1.232.56-1.722a20.11 20.11 0 0 0-3.88 4.323h.584l-1.08.784c-.167.28-.328.566-.483.855l.515 1.586-.961-.699a19.806 19.806 0 0 0-.654 1.553l.568 1.747h2.095l-1.695 1.232L2.865 18 1.17 16.768l-1.015.738C.053 18.323 0 19.156 0 20h20V0A19.905 19.905 0 0 0 9.264 3.123ZM10.04 18l-1.695-1.232L6.649 18l.647-1.993-1.695-1.232h2.095l.648-1.992.647 1.992h2.096l-1.695 1.232.647 1.993Zm-.647-7.819.647 1.993-1.695-1.232-1.695 1.232.647-1.993-1.695-1.232h2.095l.648-1.993.647 1.993h2.096l-1.695 1.232ZM17.213 18l-1.695-1.232L13.823 18l.647-1.993-1.695-1.232h2.095l.648-1.992.647 1.992h2.096l-1.695 1.232.647 1.993Zm-.648-7.819.648 1.993-1.695-1.232-1.695 1.232.647-1.993-1.695-1.232h2.095l.648-1.993.647 1.993h2.096l-1.695 1.232Zm0-5.826.648 1.993-1.695-1.232-1.695 1.232.647-1.993-1.695-1.232h2.095l.648-1.993.647 1.993h2.096l-1.695 1.232Z"
}, null, -1), s = [
  o,
  n,
  c
];
function a(d, i) {
  return t(), e("svg", h, [...s]);
}
const _ = { render: a };
export {
  _ as default,
  a as render
};
